import { MenuEntry } from '@src/menu-entry';

export default MenuEntry.create()
    .setTitle('Manuelle Buchungen')
    .setRoute('manual_booking_search');
